import { DateFormats, formatDate } from '@strata/helper-functions';
import { InfoDialog } from '@strata/react-dialog';
import PropTypes from 'prop-types';

export const ViewMetadataDialog = ({
    isOpen,
    onClose,
    status = undefined,
    metadata = undefined,
    timestamp = undefined,
}) => {
    const formattedTimestamp = formatDate(timestamp, DateFormats.DATE_TIME);

    return (
        <InfoDialog
            dialogTitle={`${status} - ${formattedTimestamp}`}
            isOpen={isOpen}
            dialogContent={
                <div style={{ wordWrap: 'normal', overflowX: 'scroll' }}>
                    {metadata && <pre>{JSON.stringify(metadata, null, 2)}</pre>}
                </div>
            }
            onClose={onClose}
            width={750}
        />
    );
};

ViewMetadataDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    status: PropTypes.string,
    timestamp: PropTypes.string,
    metadata: PropTypes.shape({}),
};
